@if (activeIndex !== -1) {
  <div class="stepper-container">
    @for (item of [].constructor(numOfSteps); track $index; let index = $index) {
      <div
        class="stepper-step"
    [ngClass]="{
      'stepper-step--active': activeIndex === index
    }"
        [attr.data-cy]="'stepper-step-' + index + (activeIndex === index ? '-active' : '') "
        >
      </div>
    }
  </div>
}
